import { Grid, Paper } from "@mui/material";
import Content from "./Content";
import Toolbar from "./Toolbar";
import GradesList from "components/GradeList";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { gradeSet, selectGrade } from "features/pacing";
import { IGrade } from "features/common/Interfaces";
import { useContext, useEffect, useState } from "react";
import DataNotFound from "components/DataNotFound";
import { useTranslation } from "react-i18next";
import { selectGrades } from "features/filters";
import { MasterDataContext } from "contexts/MasterDataContext";
const customStyles = {
  container: {
    background: "rgba(255, 255, 255, 1)",
    borderRadius: " 0 0 18px 18px",
  },
  toolBar: {
    background: "rgba(247, 248, 250, 1)",
    margin: "30px 10px",
    padding: "0 10px",
    height: "75px",
  },
  content: {
    borderRadius: "18px",
  },
};
export default function Pacing() {
  const { t } = useTranslation();
  const { logEvent } = useContext(MasterDataContext);

  const selectedGrade = useAppSelector(selectGrade);
  const [isLoading, setIsLoading] = useState(true);
  const ownedGrades = useAppSelector(selectGrades).filter(
    (grade) => grade.owned
  );
  const dispatch = useAppDispatch();
  const clickHandler = (grade: IGrade) => {
    dispatch(gradeSet(grade));
  };

  useEffect(() => {
    logEvent("VisitPacingReport");
  }, []);

  return (
    <>
      <GradesList
        onGradeChange={clickHandler}
        selectedGrade={selectedGrade}
        getIsGradeLoading={setIsLoading}
      />
      {ownedGrades.length > 0 ? (
        <Grid
          container
          direction="column"
          alignItems="stretch"
          sx={customStyles.container}
        >
          <Grid item xs={12}>
            <Paper elevation={0} sx={customStyles.toolBar}>
              <Toolbar />
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper elevation={0} sx={customStyles.content}>
              <Content />
            </Paper>
          </Grid>
        </Grid>
      ) : isLoading ? null : (
        <DataNotFound text={t("no classes")} />
      )}
    </>
  );
}
